module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('uiv-modal', {
    attrs: {
      "title": "Create Notification"
    },
    on: {
      "hide": _vm.notificationEditorClosed
    },
    model: {
      value: (_vm.showNotificationEditor),
      callback: function($$v) {
        _vm.showNotificationEditor = $$v
      },
      expression: "showNotificationEditor"
    }
  }, [_c('notification-editor', {
    attrs: {
      "message": _vm.notification.message,
      "severity": _vm.notification.severity
    },
    on: {
      "messageChange": _vm.handleMessageChange,
      "severityChange": _vm.handleSeverityChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "createNotificationButton"
    },
    on: {
      "click": function($event) {
        return _vm.createNotificationButtonClick()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-bell"
  }), _vm._v(" Create notification\n                            ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Create a user notification")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "createMaintenanceNotificationButton"
    },
    on: {
      "click": function($event) {
        return _vm.createMaintenanceNotification()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Create maintenance notification\n                            ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Create maintenance notification")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "cancelNotifications"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAllNotifications()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Clear notifications\n                            ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Remove active notifications")]), _vm._v(" "), _c('p')])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Notifications Admin")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d210766", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d210766"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/notifications/notifications-admin.vue.html
// module id = 1108
// module chunks = 0